import AlertCardV2, { ALERT_CARD_TYPE } from "./alertCardV2";
import { Box, Grid, useTheme } from "@material-ui/core";
import React, { ReactElement } from "react";

import Bold from "../typography/bold";
import GenericSvgIconWrapper from "~/icons/genericSvgIconWrapper";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import Medium from "../typography/medium";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

interface InfoAlertProps {
  message: string;
  actions?: ReactElement;
  onClose?: () => void;
  isOpen?: boolean;
  typographyWeight?: "bold" | "medium";
  type?: ALERT_CARD_TYPE.INFO | ALERT_CARD_TYPE.ERROR | ALERT_CARD_TYPE.WARNING;
  noBorder?: boolean;
}

const InfoAlertIcon = styled(Grid)`
  flex-shrink: 0;
`;

const InfoAlertText = styled(Grid)`
  flex-grow: 1;
`;

const PaddedBox = styled(Box)`
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
`;

const InfoAlertV2: React.FC<InfoAlertProps> = ({
  message,
  actions,
  typographyWeight = "medium",
  onClose,
  isOpen = true,
  type = ALERT_CARD_TYPE.INFO,
  noBorder = false,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <AlertCardV2
      isOpen={isOpen}
      type={type}
      onClose={onClose}
      noBorder={noBorder}
    >
      <Grid container spacing={1} alignItems="flex-start" wrap="nowrap">
        <InfoAlertIcon item>
          <PaddedBox>
            <GenericSvgIconWrapper $color={theme.palette[type].main}>
              {type === ALERT_CARD_TYPE.ERROR ? (
                <ReportProblemOutlinedIcon />
              ) : (
                <InfoOutlinedIcon />
              )}
            </GenericSvgIconWrapper>
          </PaddedBox>
        </InfoAlertIcon>
        <InfoAlertText item>
          <Grid
            container
            alignItems="flex-start"
            justifyContent="space-between"
            spacing={1}
          >
            <Grid item>
              <PaddedBox>
                {typographyWeight === "bold" ? (
                  <Bold variant="body1">{t(message)}</Bold>
                ) : (
                  <Medium variant="body1">{t(message)}</Medium>
                )}
              </PaddedBox>
            </Grid>
            {actions && <Grid item>{actions}</Grid>}
          </Grid>
        </InfoAlertText>
      </Grid>
    </AlertCardV2>
  );
};

export default InfoAlertV2;
